import { useConfig } from '@juvare/common-web-ui/config';
import { ContactManagementConfig, useContactManagementConfig } from '@juvare/contact-management/ui/hooks';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface AppConfig extends ContactManagementConfig {}

export function useAppConfig() {
    const contactManagementConfig = useContactManagementConfig();

    return useConfig<AppConfig>([contactManagementConfig], undefined, true);
}
